import Rating from './rating/rating.component';

export { Rating };
